import ValueSection from './value-section';

export default ValueSection;
